// extracted by mini-css-extract-plugin
module.exports = {"grid":"WeighingsGrid_grid__34gFA","zero":"WeighingsGrid_zero__24v0o","toolbar":"WeighingsGrid_toolbar__114f9","weight":"WeighingsGrid_weight__-k3IQ","th":"WeighingsGrid_th__3nkCa"};